import React, { useState ,useEffect} from "react";
import { Modal, Button } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
import axios from "axios";
import { makeStyles , Radio, RadioGroup, FormControlLabel, FormControl, FormLabel} from '@material-ui/core';
import { useHistory } from "react-router-dom";
import { NODE_API_URL } from "../../../env_config";
import { Backdrop,CircularProgress,} from "@material-ui/core";
const useStyles = makeStyles(theme => ({
    root: {
      display: 'flex',
    },
    formControl: {
      margin: theme.spacing(0),
    },
    group: {
      margin: theme.spacing(1, 0),
    },
  }));

export const RequestForInvoice = (props) => {
    const [convinienceobj,setConvinienceObj] = useState()
    const [vipdiscount,setVipDiscount] = useState(0)
    useEffect(() => {
        axios({
            method: "POST",
            url: `${NODE_API_URL}/TESTMODE/getConvinienceFee`,
            headers: { "Content-Type": "application/json" },
            data:{
                country:props.userinfo.country
            }
        })
        .then(async function(res) {
            if(res && res.data && res.data.data){
                setConvinienceObj(res.data.data)
                if (res.data.data.fedex_charges != 0 && res.data.data.ups_charges != 0 && res.data.data.hk_delivery != "Y") {                	
                    setShippingCharge(res.data.data.ups_charges);
                    setValue("ups")
				}
				if (res.data.data.fedex_charges != 0 && res.data.data.ups_charges == 0 && res.data.data.hk_delivery != "Y") {                	
                    setShippingCharge(res.data.data.fedex_charges);
                    setValue("fedex")
				}
				if (res.data.data.ups_charges != 0 && res.data.data.fedex_charges == 0 && res.data.data.hk_delivery != "Y") {
                	setShippingCharge(res.data.data.ups_charges);
                    setValue("ups")
				}
				if (res.data.data.fedex_charges != 0 && res.data.data.ups_charges != 0 && res.data.data.hk_delivery == "Y") {
                	 setShippingCharge(res.data.data.ups_charges);
                     setValue("ups")
				}
				if (res.data.data.fedex_charges == 0 && res.data.data.ups_charges == 0 && res.data.data.hk_delivery == "Y") {
                	setShippingCharge(0);
                    setValue("hkdelivery")
				}
				if (res.data.data.fedex_charges != 0 && res.data.data.ups_charges == 0 && res.data.data.hk_delivery == "Y") {
                	setShippingCharge(res.data.data.fedex_charges);
                    setValue("fedex")
				}
				if (res.data.data.fedex_charges == 0 && res.data.data.ups_charges != 0 && res.data.data.hk_delivery == "Y") {
                	 setShippingCharge(res.data.data.ups_charges);
                     setValue("ups")
				}
            }
        })
        .catch(function(res) {
            
        });
        let cgi = props.diamonddata.map(value => {
            return value.conform_good_id
        })
        axios({
            method: "POST",
            url: `${NODE_API_URL}/TESTMODE/getVipDiscount`,
            headers: { "Content-Type": "application/json" },
            data:{
                "user_id":props.userinfo.id,
                "conform_good_id":cgi
            }
        })
        .then(async function(res) {
                if(res && res.data && res.data.success){
                    setVipDiscount(res.data.vip_discount)
                }
        })
        .catch(function(res) {
            
        });
    },[])
    // console.log(selectshippingcharge,"selectshippingcharge")
    const classes = useStyles();
    const [value, setValue] = React.useState('ups');
    const history = useHistory()
    

    // const [show, setShow] = useState(false);

    // const handleClose = () => setShow(false);
    // const handleShow = () => setShow(true);
    function numberWithCommas(x) {
        if(x){
            return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
            return "0.00"
        }
    }
    const [shippingcharge,setShippingCharge] = useState(0)
    // const HandleClick = (e) => {
    //     console.log(e.target.value,"BALUEEEEE")
    //     setShippingCharge(parseFloat(e.target.value))
    // }
    function handleChange(event) {
        setValue(event.target.value);
        if(event.target.value === "ups"){
        setShippingCharge(parseFloat(convinienceobj.ups_charges))

        }
        else if(event.target.value === "fedex"){
            setShippingCharge(parseFloat(convinienceobj.fedex_charges))
        }
        else{
            setShippingCharge(0)
        }
      }
    const PerfomaInvoice = (props) => {
        const gst = 0
        const ordertotal = props.buypopupctotal + shippingcharge
        // props.onHide()
        props.GeneratePerforma(shippingcharge,props,gst,props.buypopupctotal,value,vipdiscount)
    }
    const ProccedToCheckout = () => {
        history.push({
            pathname: "/checkout",
            state: {
                diamonddata:props.diamonddata,
                shippingcharge:shippingcharge,
                shippingvalue:value
            },
                // state: decompress(res.data.ProductDetails),
            })
    }
    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onHide}
                backdrop="static"
                keyboard={false}
                size="lg"
                // className={`${
                //     props.diamond_type === "N" ? "natTab" : "labTab"
                // }`}
                className={`natTab`}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{props.language.REQ_INVOICE_MSG}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-12 mt-4">
                           <span className="pr-3 mr-3 border-right"> {props.language.CONFIRM_GOODS_POPUP_TOTAL_DIAMONDS} : {props.diamonddata.length} Pcs</span >
                           <span> {props.language.REQ_TOTAL_CARAT} : {numberWithCommas(props.totalcarat)}</span >
                        </div>
                        <div className="col-12">
                            <div
                                className="custom-scrollbar"
                                style={{ maxHeight: "322px" }}
                            >
                                <table className="table border-bottom">
                                    <thead>
                                        <tr className="bg-gray-100 sticky-top">
                                            <th align="center" className="text-center py-3"><p className="mb-2">{props.language.CONFIRM_GOODS_POPUP_DIAMOND_DETAILS}</p></th>
                                            <th className="text-center py-3">
                                                {props.language.CONFIRM_GOODS_POPUP_DIAMOND_LOCATION} 
                                            </th>
                                            <th align="center" className="text-right py-3">
                                                {props.language.CONFIRM_GOODS_POPUP_OURPRICE} <br />
                                                $/CT
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.diamonddata.map((value => (
                                            <tr className={`${value.perfoma_no? "CanNotHoldDiv" : "" }`}>
                                                
                                            <td>
                                               <div className={`row`}>
                                               
                                                   <div className="col-2 text-center p-0">
                                                        <img className="img-fluid mr-2" alt={ value.C_Shape } src={toAbsoluteUrl( `/media/shape/${value.C_Shape.toLowerCase()}-no.png` )} width="50px" style={{ backgroundColor: "#f4f4f4", }} />
                                                   </div>
                                                   <div className="col-10 pl-2 p-0">
                                                        <div className="mb-1">
                                                        {value.perfoma_no?
                                                    <span className="CanNotHold">Proforma already generated please contact your sales executive</span>
                                                :""}
                                                            <span
                                                                className={`${
                                                                    value.diamond_type ===
                                                                    "N"
                                                                        ? value.C_Color ===
                                                                          "fancy"
                                                                            ? "F"
                                                                            : "W"
                                                                        : value.C_Color ===
                                                                          "fancy"
                                                                        ? "LF"
                                                                        : "L"
                                                                }_diamond mr-3 small`}
                                                            >
                                                                {value.diamond_type ===
                                                                "N"
                                                                    ? value.C_Color ===
                                                                      "fancy"
                                                                        ? "F"
                                                                        : "W"
                                                                    : value.C_Color ===
                                                                      "fancy"
                                                                    ? "LF"
                                                                    : "L"}
                                                            </span>
                                                            <span className="text-primary small">
                                                                {value.Lab}-
                                                                {value.Certi_NO}
                                                            </span>
                                                            <span className="small ml-2">
                                                                {value.diamond_type ===
                                                                "N"
                                                                    ? "N"
                                                                    : "L"}
                                                                -{value.Stock_NO}
                                                            </span>
                                                        </div>

                                                        <span className="text-dark font-weight-bold d-block">
                                                            {value.C_Shape}{" "}
                                                            {value.C_Weight}{" "}
                                                            {value.C_Color ===
                                                            "fancy" ? (
                                                                <>
                                                                    {
                                                                        value.f_intensity
                                                                    }{" "}
                                                                    {
                                                                        value.f_overtone
                                                                    }{" "}
                                                                    {
                                                                        value.f_color
                                                                    }{" "}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    {
                                                                        value.C_Color
                                                                    }{" "}
                                                                </>
                                                            )}
                                                            {value.C_Clarity}{" "}
                                                            {value.C_Cut}{" "}
                                                            {value.C_Polish}{" "}
                                                            {value.C_Symmetry}{" "}
                                                            {
                                                                value.C_Fluorescence
                                                            }{" "}
                                                        </span>
                                                    
                                                    </div>
                                               </div>
                                           </td>
                                           <td className="text-center">
                                           {value.country} <br />
                                           </td>
                                           <td className={`text-right`}>
                                                <span className="text-primary font-weight-bold">${numberWithCommas(parseFloat(value["OurPrice(INR)"]))}</span ><br/>
                                                <span className="text-muted small">$/CT {numberWithCommas(parseFloat(value["INR/Ct"]))} <br /></span >
                                           </td>
                                       </tr>
                                        )))}

                                    </tbody>
                                </table>
                            </div>
                            <div className="row mt-5 m-0">
                                <div className="col-md-5">
                                    <div className={classes.root}>
                                        <FormControl component="fieldset" className={classes.formControl}>
                                            <FormLabel component="legend">{props.language.REQ_SELECT_SHIPPING}:</FormLabel>
                                            <RadioGroup
                                            aria-label="Select Shipping Method:"
                                            name="Shipping"
                                            className={classes.group}
                                            value={value}
                                            onChange={handleChange}
                                            >
                                                {/* <FormControlLabel value="40" control={<Radio />} label="FEDEX" />
                                                <FormControlLabel value="25" control={<Radio />} label="UPS" /> */}
                                                {convinienceobj && convinienceobj.fedex_charges != 0 && convinienceobj.ups_charges != 0 && convinienceobj.hk_delivery != "Y"?
                                                <>
                                                <FormControlLabel value="fedex" control={<Radio />} label="FEDEX" />
                                                <FormControlLabel value="ups" control={<Radio />} label="UPS" /></>
                                                :""}

                                                {convinienceobj && convinienceobj.fedex_charges != 0 && convinienceobj.ups_charges == 0 && convinienceobj.hk_delivery != "Y"?
                                                <>
                                                <FormControlLabel value="fedex" control={<Radio />} label="FEDEX" />
                                                </>
                                                :""}

                                                {convinienceobj && convinienceobj.ups_charges != 0 && convinienceobj.fedex_charges == 0 && convinienceobj.hk_delivery != "Y"?
                                                <>
                                                <FormControlLabel value="ups" control={<Radio />} label="UPS" />
                                                </>
                                                :""}

                                                {convinienceobj && convinienceobj.fedex_charges != 0 && convinienceobj.ups_charges != 0 && convinienceobj.hk_delivery == "Y"?
                                                <>
                                                <FormControlLabel value="fedex" control={<Radio />} label="FEDEX" />
                                                <FormControlLabel value="ups" control={<Radio />} label="UPS" />
                                                <FormControlLabel value="hkdelivery" control={<Radio />} label="HK DELIVERY" />
                                                </>
                                                :""}

                                                {convinienceobj && convinienceobj.fedex_charges == 0 && convinienceobj.ups_charges == 0 && convinienceobj.hk_delivery == "Y"?
                                                <>
                                                <FormControlLabel value="hkdelivery" control={<Radio />} label="HK DELIVERY" />
                                                </>
                                                :""}

                                                {convinienceobj && convinienceobj.fedex_charges != 0 && convinienceobj.ups_charges == 0 && convinienceobj.hk_delivery == "Y"?
                                                <>
                                                <FormControlLabel value="fedex" control={<Radio />} label="FEDEX" />
                                                <FormControlLabel value="hkdelivery" control={<Radio />} label="HK DELIVERY" />
                                                </>
                                                :""}

                                                {convinienceobj && convinienceobj.fedex_charges == 0 && convinienceobj.ups_charges != 0 && convinienceobj.hk_delivery == "Y"?
                                                <>
                                                <FormControlLabel value="ups" control={<Radio />} label="FEDEX" />
                                                <FormControlLabel value="hkdelivery" control={<Radio />} label="HK DELIVERY" />
                                                </>
                                                :""}
                                            </RadioGroup>
                                        </FormControl>
                                        
                                    </div>
                                    <div>{props.language.REQIN_POPUP_PAR1}</div>
                                </div>
                                
                                <div className="col-md-7">
                                    <div className="row border rounded bg-primary-o-20 py-5">
                                        <div className="col-12 font-size-h6 text-right d-flex justify-content-between">
                                            <span>{props.language.REQ_DIAMOND_DIAMOND_PRICE} :</span> <span>${numberWithCommas(props.buypopupctotal)}</span>
                                        </div>
                                        {shippingcharge?<div className="col-12 font-size-h6 mt-2 mb-2 text-right d-flex justify-content-between">
                                            <span>{props.language.REQ_DIAMOND_CONVINIENCE_FEE}:</span> <span>${numberWithCommas(shippingcharge)}</span>
                                        </div>:""}
                                        {vipdiscount?<div className="col-12 font-size-h6 mt-2 mb-2 text-right d-flex justify-content-between">
                                            <span>{props.language.INVOICE_SERVICE_CHARGE_DISCOUNT} :</span> <span className="text-danger">-${numberWithCommas(vipdiscount)}</span>
                                        </div>:""}
                                        <div className="col-12 font-size-h4 border-top mt-2 pt-2 text-right font-weight-bold text-danger d-flex justify-content-between">
                                            <span>{props.language.REQ_TOTAL_DIAMOND_PRICE} :</span>  <span>${numberWithCommas(props.buypopupctotal + shippingcharge - vipdiscount)}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <pre>{JSON.stringify(props)}</pre> */}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="justify-content-center">
                    <Button className="px-8 btn-pill" variant="outline-secondary" size="lg" onClick={() => ProccedToCheckout(props)}>
                        {props.language.REQ_INVOICE_PAYVIACC}
                    </Button>
                    <Button disabled={props.isSubmitting} className="px-8 btn-pill" variant="primary" size="lg" onClick={() => PerfomaInvoice(props)}>
                        {props.language.REQ_TOTAL_PAYBANKWIRE}
                        {props.loading && <span className="ml-1 spinner spinner-white"></span>}
                        <Backdrop
                            sx={{ color: '#002173', zIndex: (theme) => theme.zIndex.drawer + 5 }}
                            open={props.openLoader}
                            // onClick={handleCloseLoader}
                        >
                            <CircularProgress color="secondary" />
                        </Backdrop>
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};
